// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"187":"6c561319","286":"31abc6ef","379":"9702933e","616":"22f1cbcd","630":"50381d4d","717":"a0df9c10","787":"3ba5e41c","896":"2e53e9bf"}[chunkId] + ".chunk.js";
};